var exports = {
  "u": "automatedReviewDiff__bj31lr",
};

module.exports = exports;
